import { Text } from "@overmap-ai/blocks"
import { type Asset, type Stored, UNLABELLED_ASSET_LABEL } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { interactiveTextCva } from "../../cva"
import { ProjectTimelineItemType } from "../../enums/projects"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { AssetTypeIcon } from "../Icons/AssetTypeIcon"
import { AssetIndexLabel } from "../IndexLabels/AssetIndexLabel"
import { ProjectTimelineCard } from "./ProjectTimelineCard"

interface ProjectTimelineAssetItemProps {
	asset: Stored<Asset>
}

export const ProjectTimelineAssetItem = memo<ProjectTimelineAssetItemProps>((props) => {
	const { asset } = props

	const user = useAppSelector(selectUserById(asset.created_by ?? -1))

	return (
		<ProjectTimelineCard type={ProjectTimelineItemType.ASSET}>
			<Text size="sm" accentColor="base" className="min-w-0">
				<Text highContrast>{getUserDisplayLabel(user)}</Text>
				&nbsp;created asset&nbsp;
				<Link
					from="/$organizationId/$projectId"
					to="/$organizationId/$projectId/assets/$assetId"
					params={{ assetId: asset.uuid }}
				>
					<AssetTypeIcon className="align-sub" assetTypeId={asset.asset_type} />
					&nbsp;
					<Text className={interactiveTextCva()} accentColor="base">
						<AssetIndexLabel assetId={asset.uuid} highContrast />
						&nbsp;
						<Text>{asset.label || UNLABELLED_ASSET_LABEL}</Text>
					</Text>
				</Link>
				<Text accentColor="base">&nbsp;&#8226;&nbsp;{formatCompactDate(asset.submitted_at)}</Text>
			</Text>
		</ProjectTimelineCard>
	)
})
ProjectTimelineAssetItem.displayName = "ProjectTimelineAssetItem"
